import { categoryMenInterior, categoryMenShelves, categoryMenSweatshirts } from '@/assets/images';

export default function CategoryMen() {
  return (
    <section id="hombre" className="py-24 md:py-32 bg-cream-100">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="lg:pr-10 order-2 lg:order-1">
          <p className="text-[11px] tracking-widest-xl text-ink-500 mb-6">COLECCIÓN 2026</p>
          <h2 className="font-display text-5xl md:text-7xl text-ink-900 mb-8">Hombre</h2>
          <div className="w-16 h-px bg-ink-900/40 mb-8"></div>
          <p className="text-ink-700 text-base md:text-[17px] leading-relaxed max-w-md mb-10">
            Estilo, personalidad y prendas seleccionadas para formar parte de tu día a día. Contamos con marcas modernas y de alta calidad como Teckel, Tifossi, Jack &amp; Jones, Levi's, entre otras. Básicos esenciales y detalles que marcan la diferencia.
          </p>
        </div>
        <div className="order-1 lg:order-2 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          <div className="hover-zoom overflow-hidden">
            <img
              src={categoryMenSweatshirts}
              alt="Cartel de sudaderas de invierno de Jack & Jones en Sano con cuatro modelos de hombre"
              title="Sudaderas de invierno Jack & Jones en Sano Llíria"
              className="w-full h-auto block"
            />
          </div>
          <div className="grid grid-rows-2 gap-4 md:gap-6">
            <div className="hover-zoom overflow-hidden">
              <img
                src={categoryMenInterior}
                alt="Interior de la tienda con la colección de hombre"
                title="Colección hombre Sano Llíria"
                className="w-full h-[260px] sm:h-full object-cover object-center"
              />
            </div>
            <div className="hover-zoom overflow-hidden">
              <img
                src={categoryMenShelves}
                alt="Estanterías con prendas de hombre ordenadas por colores"
                title="Moda hombre Sano Llíria"
                className="w-full h-[260px] sm:h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
